export default{
    en:{
        tab:{
            user:'사용자관리',
            major:'Major Management',
            volunteerOnOffCampusScore:'Service Score',
            volunteerOnCampusPropagateScore:'Appointment Score',
            achievementScore:'기준점수관리',
            achievementScoreRatio:'평가계산식관리',
            journal:'학술지등급관리',
            plan:'업적계획서관리',
            judgementTargets:'심사대상자관리'
        },
        list:{
            scoreCopy:'Score Copy',
            werks:'Campus',
            year:'Year',
            zTerm:'Term {count}',
			rfield:'연구분야',
            user:{
                roleId:'권한코드',
                roleNm:'권한명칭',
                empNo:'사용자ID',
                korNm:'사용자명',
                orgtx0:'부서명',
                regno:'주민등록번호',
                useYn:'사용여부',
            },
            judgementTargets:{
                id:'관리번호',
                major:'학과',
                year:'학년',
                judgementType:'심사 구분',
                empNo:'사용자ID',
                name:'사용자명',
                orgtx0:'부서명',
                judgementFrom:'심사 시작일',
                judgementTo:'심사 종료일',
                standardScoreAll:'기준점수(전체)',
                standardScore:'기준점수(연구)',
                judgement:'심사신청',
                promo:'승진대상(A)',
                payIncrease:'승봉대상(B)',
                reappoint:'재임용대상(C)',
                total:'전체(Total)',
            },
            major:{
                major:'Major',
                korNm:'Korean',
                engNm:'English',
                preMajor:'University',
                ord:'Sort',
            },
            volunteerOnOffCampusScore:{
                serviceDiv:'Service Type',
                serviceCd:'Service Code',
                serviceNm:'Service Name',
                reportUseType:'Report Use Type',
            },
            volunteerOnCampusPropagateScore:{
                posit:'Code',
                postx:'행정보직명',
                addRate1:'Rate1',
                addRate2:'Rate2',
            },
            achievementScore:{
                inDate:'임용기준일',
                hyhg:'학년도학기',
                mark:'Points',
                markF:'시작점수',
                markT:'종료점수',
                article:{
                    grade:'논문등급',
                },
                book:{
                    gubun:'Classification',
                    gubun2:'등급',
                },
                exhibition:{
                    gubun1:'대분류',
                    gubun2:'중분류',
                    gubun3:'Ranking',
                },
                conference:{
                    gubun:'Classification',
                },
                funding:{
                    amountF:'연구비From',
                    amountT:'연구비To',
                },
                patent:{
                    gubun:'지적재산권구분',
                    markC:'출원점수',
                    markD:'등록점수'
                },
                techtrans:{
                    amountF:'기술이전비From',
                    amountT:'기술이전비To',
                },
            },
            achievementScoreRatio:{
                authorCntF:'Number of Authors From',
                authorCntT:'Number of Authors To',
                mper1:'점수적용비율',
                mper2:'추가적용점수비율',
            },
            journalManagement:{
                journal:'Journal',
                publish:'Publish',
                addYear:'Reference Year',
                idx1:'Journal Grade',
                grade:'GRADE',
                major:'MAJOR',
                if:'전년도 IF',
            },
            achvmPlan:{
                achvmPlanType:'Evaluation Type',
                promotion: 'Promotion',
                reappointment: 'Reappointment',
                payGradeIncrease: 'Pay Grade Increase',
                empNo:'교원',
                period:'기간',
                title:'Title',
                regDt:'Date',
            },
        },
        detail:{
            ord:'Sort',
            werks:'Campus',
            year:'Year',
            zTerm:'Term',
			rfield:'연구분야',
            user:{
                empNo:'사용자',
                orgtx0:'부서명',
                roleId:'사용자권한',
                useYn:'사용유무',
                deptId:'관리대상',
            },
            major:{
                major:'Major Code',
                name:'Major Name',
                korNm:'Korean',
                engNm:'English',
                preMajor:'University',
                remrk:'Remark',
            },
            volunteerOnOffCampusScore:{
                serviceDiv:'Service Type',
                serviceCd:'Service Code',
                serviceNm:'Service Name',
                reportUseType:'Report Use Type',
            },
            volunteerOnCampusPropagateScore:{
                posit:'행정보직코드',
                postx:'행정보직명',
                addRate1:'Application Rate 1',
                addRate2:'Application Rate 2',
            },
            journalManagement:{
                major:'Major',
                journal:'Journal',
                publish:'Publish',
                grade:'Grade',
                issnno:'Issn No.',
                if:'전년도 IF',
                idx1:'Journal Grade',
                addYear:'Reference Year',
            },
			achievementScore:{
				inDate:'임용기준일',
				mark:'Points',
				markF:'시작점수',
				markT:'종료점수',
				article:{
					grade:'논문등급',
				},
				book:{
					gubun:'Classification',
					gubun2:'등급',
				},
				exhibition:{
					gubun1:'대분류',
					gubun2:'중분류',
					gubun3:'Ranking',
				},
				conference:{
					gubun:'Classification',
				},
				funding:{
					amountF:'연구비From',
					amountT:'연구비To',
				},
				patent:{
					gubun:'지적재산권구분',
					markC:'출원점수',
					markD:'등록점수'
				},
				techtrans:{
					amountF:'기술이전비From',
					amountT:'기술이전비To',
				},
			},
			achievementScoreRatio:{
				authorCntF:'Number of Authors From',
				authorCntT:'Number of Authors To',
				mper1:'점수적용비율',
				mper2:'추가적용점수비율',
			},
        },
    },
    ko:{
        tab:{
            user:'사용자관리',
            major:'전공관리',
            volunteerOnOffCampusScore:'교내/외봉사점수',
            volunteerOnCampusPropagateScore:'봉사(보직)점수',
            achievementScore:'기준점수관리',
            achievementScoreRatio:'평가계산식관리',
            journal:'학술지등급관리',
            plan:'업적계획서관리',
            judgementTargets:'심사대상자관리'
        },
        list:{
            scoreCopy:'점수복사',
            werks:'캠퍼스',
            year:'학년도',
            zTerm:'{count}학기',
			rfield:'연구분야',
            user:{
                roleId:'권한코드',
                roleNm:'권한명칭',
                empNo:'사용자ID',
                korNm:'사용자명',
                orgtx0:'부서명',
                regno:'주민등록번호',
                useYn:'사용여부',
            },
            major:{
                major:'전공코드',
                korNm:'한글명',
                engNm:'영문명',
                preMajor:'대학명',
                ord:'Sort'
            },
            volunteerOnOffCampusScore:{
                serviceDiv:'봉사활동구분',
                serviceCd:'코드',
                serviceNm:'봉사활동명',
                reportUseType:'보고서점수반영부분',
            },
            volunteerOnCampusPropagateScore:{
                posit:'코드',
                postx:'행정보직명',
                addRate1:'적용률1',
                addRate2:'적용률2',
            },
            achievementScore:{
                inDate:'임용기준일',
                mark:'점수',
                markF:'시작점수',
                markT:'종료점수',
                article:{
                    grade:'논문등급',
                },
                book:{
                    gubun:'구분',
                    gubun2:'등급',
                },
                exhibition:{
                    gubun1:'대분류',
                    gubun2:'중분류',
                    gubun3:'등급',
                },
                conference:{
                    gubun:'구분',
                },
                funding:{
                    amountF:'연구비From',
                    amountT:'연구비To',
                },
                patent:{
                    gubun:'지적재산권구분',
                    markC:'출원점수',
                    markD:'등록점수'
                },
                techtrans:{
                    amountF:'기술이전비From',
                    amountT:'기술이전비To',
                }
            },
            achievementScoreRatio:{
                hyhg:'학년도학기',
                authorCntF:'저자수 From',
                authorCntT:'저자수 To',
                mper1:'점수적용비율',
                mper2:'추가적용점수비율',
            },
            journalManagement:{
                journal:'학술지명',
                publish:'발행기관',
                addYear:'선정년도',
                idx1:'학술지 등급',
                grade:'등급',
                major:'대학/학과',
                if:'전년도 IF',
            },
            achvmPlan:{
                achvmPlanType:'심사구분',
                promotion: '승진',
                reappointment: '재임용',
                payGradeIncrease: '승봉',
                empNo:'교원',
                period:'기간',
                title:'제목',
                regDt:'등록일자',
            },
            judgementTargets:{
                id:'관리번호',
                major:'학과',
                year:'학년',
                judgementType:'심사 구분',
                empNo:'사용자ID',
                name:'사용자명',
                orgtx0:'부서명',
                judgementFrom:'심사 시작일',
                judgementTo:'심사 종료일',
                standardScoreAll:'기준점수(전체)',
                standardScore:'기준점수(연구)',
                judgement:'심사신청',
                promo:'승진대상(A)',
                payIncrease:'승봉대상(B)',
                reappoint:'재임용대상(C)',
                total:'전체(Total)',
            },
        },
        detail:{
            ord:'Sort',
            werks:'캠퍼스',
            year:'학년도',
            zTerm:'학기',
			rfield:'연구분야',
            user:{
                empNo:'사용자',
                orgtx0:'부서명',
                roleId:'사용자권한',
                useYn:'사용유무',
                deptId:'관리대상',
            },
            major:{
                major:'전공코드',
                name:'전공명',
                korNm:'한글명',
                engNm:'영문명',
                preMajor:'대학명',
                remrk:'비고',
            },
            volunteerOnOffCampusScore:{
                serviceDiv:'봉사활동구분',
                serviceCd:'코드',
                serviceNm:'봉사활동명',
                reportUseType:'보고서점수반영구분',
            },
            volunteerOnCampusPropagateScore:{
                posit:'행정보직코드',
                postx:'행정보직명',
                addRate1:'적용률1',
                addRate2:'적용률2',
            },
            journalManagement:{
                major:'전공',
                journal:'학술지명',
                publish:'발행기관',
                grade:'등급',
                issnno:'Issn No.',
                if:'전년도 IF',
                idx1:'학술지 등급',
                addYear:'선정년도',
            },
			achievementScore:{
				inDate:'임용기준일',
				mark:'점수',
				markF:'시작점수',
				markT:'종료점수',
				article:{
					grade:'논문등급',
				},
				book:{
					gubun:'구분',
					gubun2:'등급',
				},
				exhibition:{
					gubun1:'대분류',
					gubun2:'중분류',
					gubun3:'등급',
				},
				conference:{
					gubun:'구분',
				},
				funding:{
					amountF:'연구비From',
					amountT:'연구비To',
				},
				patent:{
					gubun:'지적재산권구분',
					markC:'출원점수',
					markD:'등록점수'
				},
				techtrans:{
					amountF:'기술이전비From',
					amountT:'기술이전비To',
				},
			},
			achievementScoreRatio:{
				authorCntF:'저자수 From',
				authorCntT:'저자수 To',
				mper1:'점수적용비율',
				mper2:'추가적용점수비율',
			},
        },
    },
}